export const RWA_CUSTODY_VAULT_721_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "onCBC721Received",
    "outputs": [
      {
        "internalType": "bytes4",
        "name": "",
        "type": "bytes4"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "onERC721Received",
    "outputs": [
      {
        "internalType": "bytes4",
        "name": "",
        "type": "bytes4"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "collection",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "recipient",
        "type": "address"
      }
    ],
    "name": "releaseErc721To",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const RWA_CUSTODY_VAULT_721_BYTECODE = "0x608060405234801561001057600080fd5b50600080546001600160b01b031916339081178255604051909182917f6706336cd2535bfac8a54fc906c5d5bf89c8a10509b1188ec4664ee2acadd6b4908290a3506104bf806100616000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c806392c1ad441461005c578063aae7857b14610099578063be0e67a3146100ae578063f06a572d146100d9578063f265137a146100ec575b600080fd5b61007b61006a3660046103b8565b6324b06b5160e21b95945050505050565b6040516001600160e01b031990911681526020015b60405180910390f35b6100ac6100a7366004610397565b61010b565b005b6000546100c1906001600160b01b031681565b6040516001600160b01b039091168152602001610090565b6100ac6100e736600461044e565b610200565b61007b6100fa3660046103b8565b63793289bd60e11b95945050505050565b6000546001600160b01b0316336001600160b01b031614610161576040516327200e5f60e11b815260206004820152600a60248201526927b7363c9037bbb732b960b11b60448201526064015b60405180910390fd5b61016a81610306565b156101a5576040516327200e5f60e11b815260206004820152600a6024820152692d32b9379037bbb732b960b11b6044820152606401610158565b600080546040516001600160b01b03808516939216917f6706336cd2535bfac8a54fc906c5d5bf89c8a10509b1188ec4664ee2acadd6b491a3600080546001600160b01b0319166001600160b01b0392909216919091179055565b6000546001600160b01b0316336001600160b01b031614610251576040516327200e5f60e11b815260206004820152600a60248201526927b7363c9037bbb732b960b11b6044820152606401610158565b61025a81610306565b15610299576040516327200e5f60e11b815260206004820152600e60248201526d16995c9bc81c9958da5c1a595b9d60921b6044820152606401610158565b604051631a29dd2560e11b81523060048201526001600160b01b03828116602483015260448201849052841690633453ba4a90606401600060405180830381600087803b1580156102e957600080fd5b505af11580156102fd573d6000803e3d6000fd5b50505050505050565b60006001600160b01b0382161580610336575061032161033c565b6001600160b01b0316826001600160b01b0316145b92915050565b600046600160ff82161415610357576132d560a21b91505090565b8060ff166003141561036f576155b960a11b91505090565b61ce4560a01b91505090565b80356001600160b01b038116811461039257600080fd5b919050565b6000602082840312156103a8578081fd5b6103b18261037b565b9392505050565b6000806000806000608086880312156103cf578081fd5b6103d88661037b565b94506103e66020870161037b565b935060408601359250606086013567ffffffffffffffff80821115610409578283fd5b818801915088601f83011261041c578283fd5b81358181111561042a578384fd5b89602082850101111561043b578384fd5b9699959850939650602001949392505050565b600080600060608486031215610462578283fd5b61046b8461037b565b9250602084013591506104806040850161037b565b9050925092509256fea2646970667358221220d64c5847713ee68a974c60f628634dfdbd4685ace78ff9bb4e67c3bd1708effe64736f6c63430101020033";

export const RWA_CUSTODY_VAULT_721_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\r\npragma solidity ^1.1.2;\r\n\r\nimport \"openzeppelin-contracts/utils/Context.sol\";\r\nimport \"openzeppelin-contracts/utils/Checksum.sol\";\r\nimport \"openzeppelin-contracts/token/CRC721/ICRC721Receiver.sol\";\r\n\r\n/**\r\n * @title RwaCustodyVault721\r\n * @notice Custody vault on Core OpenZeppelin `Context` + `Checksum`; receiver hooks use Core-computed selectors\r\n *         (`ICRC721Receiver` + CBC721 `onCBC721Received`), matching commodity-units keccak / CRC patterns.\r\n */\r\ninterface IERC721Minimal {\r\n    function safeTransferFrom(address from, address to, uint256 tokenId) external;\r\n}\r\n\r\ninterface ICBC721ReceiverVault {\r\n    function onCBC721Received(address operator, address from, uint256 tokenId, bytes calldata data)\r\n        external\r\n        returns (bytes4);\r\n}\r\n\r\ncontract RwaCustodyVault721 is Context {\r\n    bytes4 private constant _ERC721_RECEIVED = ICRC721Receiver.onERC721Received.selector;\r\n    bytes4 private constant _CBC721_RECEIVED = ICBC721ReceiverVault.onCBC721Received.selector;\r\n\r\n    address public owner;\r\n\r\n    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);\r\n\r\n    function _isZeroLike(address account) private view returns (bool) {\r\n        return account == address(0) || account == Checksum.zeroAddress();\r\n    }\r\n\r\n    modifier onlyOwner() {\r\n        require(_msgSender() == owner, \"Only owner\");\r\n        _;\r\n    }\r\n\r\n    constructor() {\r\n        address deployer = _msgSender();\r\n        owner = deployer;\r\n        emit OwnershipTransferred(address(0), deployer);\r\n    }\r\n\r\n    function transferOwnership(address newOwner) external onlyOwner {\r\n        require(!_isZeroLike(newOwner), \"Zero owner\");\r\n        emit OwnershipTransferred(owner, newOwner);\r\n        owner = newOwner;\r\n    }\r\n\r\n    function onCBC721Received(address, address, uint256, bytes calldata) external pure returns (bytes4) {\r\n        return _CBC721_RECEIVED;\r\n    }\r\n\r\n    function onERC721Received(address, address, uint256, bytes calldata) external pure returns (bytes4) {\r\n        return _ERC721_RECEIVED;\r\n    }\r\n\r\n    function releaseErc721To(address collection, uint256 tokenId, address recipient) external onlyOwner {\r\n        require(!_isZeroLike(recipient), \"Zero recipient\");\r\n        IERC721Minimal(collection).safeTransferFrom(address(this), recipient, tokenId);\r\n    }\r\n}\r\n";

export const RWA_CUSTODY_VAULT_721 = {
  contractName: "RwaCustodyVault721",
  abi: RWA_CUSTODY_VAULT_721_ABI,
  abiJson: JSON.stringify({ abi: RWA_CUSTODY_VAULT_721_ABI, methodIdentifiers: {"onCBC721Received(address,address,uint256,bytes)":"92c1ad44","onERC721Received(address,address,uint256,bytes)":"f265137a","owner()":"be0e67a3","releaseErc721To(address,uint256,address)":"f06a572d","transferOwnership(address)":"aae7857b"} }),
  bytecode: RWA_CUSTODY_VAULT_721_BYTECODE,
  mintFunctionName: "",
  soliditySource: RWA_CUSTODY_VAULT_721_SOLIDITY_SOURCE,
  sourceFileName: "RwaCustodyVault721.sol"
};
